export const formatCurrency = (amount: number): string =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount || 0);

export const formatPercent = (value: number): string =>
  new Intl.NumberFormat("en-IN", {
    style: "percent",
    maximumFractionDigits: 1,
  }).format(Number.isFinite(value) ? value : 0);

export const formatMonth = (monthKey: string): string =>
  new Date(`${monthKey}-01T00:00:00`).toLocaleString("en-IN", {
    month: "long",
    year: "numeric",
  });

